import React, { Component } from 'react'
import styles from "./ToolBar.module.css"

import DownloadComp from "../../util/DownloadComp"

import { AlphaPicker, HuePicker } from 'react-color'
import { v4 as uuidv4 } from 'uuid';

const SHAPE_TYPE = {
    TEXT: "FloatText",
    ANCHOR: "CtxCompAnchor",
    RECT: "CtxCompRect",
    CIRCLE: "CtxCompCircle",
    RECT_WRAP: "CtxCompRectWrap",
    CIRCLE_WRAP: "CtxCompCircleWrap",
}
export default class ToolBar extends Component {
    constructor(props) {
        super(props);
        this.state = {
            color: "#FFFFFF",
            rgba: { r: 0, g: 0, b: 0, a: 1 }
        }

        this.renderCount = 0
    }

    // Handler
    colorChangeHandler = (color) => {
        this.setState(state => { return { color: color.hex } }, () => {
            if (this.props.colorPickHandler)
                this.props.colorPickHandler(this.state.color, this.state.rgba.a)
        })
    }
    alphaChangeHandler = (rgba) => {
        this.setState(state => { return { rgba: rgba.rgb } }, () => {
            if (this.props.colorPickHandler)
                this.props.colorPickHandler(this.state.color, this.state.rgba.a)
        })
    }
    toggleCompHandler = (e, updateType = null) => {
        this.props.toggleToolHandler({ updateType: updateType })
    }

    // sub-components
    textIcon = (id) => {
        return (
            <div id={id} key={id} className={styles.textClass}
                onClick={(e) => this.toggleCompHandler(e, SHAPE_TYPE.TEXT)}>
                <img className={styles.imgIconStyle} src="https://img.icons8.com/external-prettycons-flat-prettycons/47/000000/external-text-text-formatting-prettycons-flat-prettycons.png" />
            </div>
        )
    }

    anchorIcon = (id) => {
        return (
            <div id={id} key={id} className={styles.anchorClass}
                onClick={(e) => this.toggleCompHandler(e, SHAPE_TYPE.ANCHOR)}>
                <img className={styles.imgIconStyle} src="https://img.icons8.com/color/48/000000/arrow--v2.png" />
            </div>
        )
    }

    rectWrapeIcon = (id) => {
        return (
            <div id={id} key={id} className={styles.rectClass}
                onClick={(e) => this.toggleCompHandler(e, SHAPE_TYPE.RECT_WRAP)}>
                <img className={styles.imgIconStyle} src="https://img.icons8.com/color/48/000000/rectangle-stroked.png" />
            </div>
        )
    }

    circleWrapeIcon = (id) => {
        return (
            <div id={id} key={id} className={styles.circleClass}
                onClick={(e) => this.toggleCompHandler(e, SHAPE_TYPE.CIRCLE_WRAP)}>
                <img className={styles.imgIconStyle} src="https://img.icons8.com/color/48/000000/circled.png" />
            </div>
        )
    }

    rectIcon = (id) => {
        return (
            <div id={id} key={id} className={styles.rectClass}
                onClick={(e) => this.toggleCompHandler(e, SHAPE_TYPE.RECT)}>
                <img className={styles.imgIconStyle} src="https://img.icons8.com/color/48/000000/rectangle.png" />
            </div>
        )
    }

    circleIcon = (id) => {
        return (
            <div id={id} key={id} className={styles.circleClass}
                onClick={(e) => this.toggleCompHandler(e, SHAPE_TYPE.CIRCLE)}>
                <img className={styles.imgIconStyle} src="https://img.icons8.com/color/48/000000/filled-circle.png" />
            </div>
        )
    }

    createShapeList = () => {
        const toolList = [
            this.textIcon("text-icon"),
            this.anchorIcon("anchor-icon"),
            this.rectWrapeIcon("rect-wrap-icon"),
            this.circleWrapeIcon("circle-wrap-icon"),
            this.rectIcon("rect-icon"),
            this.circleIcon("circle-icon"),
        ]

        return (
            <div className={styles.shapeListStyle}>
                {toolList}
            </div>
        )

    }
    createControlList = () => {
        var color = this.state.color
        var rgba = this.state.rgba
        if (this.props.defaultColor.color && this.renderCount > 0) {
            if (this.props.defaultColor.color != this.state.color) {
                color = this.props.defaultColor.color
                rgba.a = this.props.defaultColor.alpha
                this.colorChangeHandler({ hex: color })
                this.alphaChangeHandler({ rgb: rgba })
            }
        }

        return [
            <HuePicker key={"hue-picker"} color={color} onChange={this.colorChangeHandler} />,
            <AlphaPicker key={"alpha-picker"} color={rgba} onChange={this.alphaChangeHandler} />
        ]
    }

    createDownloadList = () => {
        return [
            <DownloadComp key={"download-pdf"} type="PDF" />,
            <DownloadComp key={"download-png"} type="PNG" />
        ]
    }
    // life cycle
    componentDidMount() {
        this.renderCount++
    }
    render() {
        const shapeList = this.createShapeList()
        const controlList = this.createControlList()
        const downloadList = this.createDownloadList()

        return (
            <div className={styles.container}>
                <div className={styles.controlListStyle}>
                    {shapeList}
                    {controlList}
                    {downloadList}
                </div>
            </div>
        )
    }
}
